import DOMPurify from "dompurify"
import { getCSSFromStyleObject, getStyleObjectFromCSS } from "@lexical/selection"

const ALLOWED_STYLE_PROPERTIES = [
  "color",
  "background-color",
  "text-align",
  "align-items"
]

function styleFilterHookOverride(_currentNode, hookEvent) {
  const tagName = _currentNode?.tagName?.toLowerCase()

  // Allow external attribute on attachment tags
  if (hookEvent.attrName === "external" && tagName?.endsWith("attachment")) {
    hookEvent.forceKeepAttr = true
    return
  }

  // Allow text-align in styles
  if (hookEvent.attrName === "style" && hookEvent.attrValue) {
    const styles = { ...getStyleObjectFromCSS(hookEvent.attrValue) }
    const sanitizedStyles = {}

    for (const property in styles) {
      if (ALLOWED_STYLE_PROPERTIES.includes(property)) {
        sanitizedStyles[property] = styles[property]
      }
    }

    if (Object.keys(sanitizedStyles).length) {
      hookEvent.attrValue = getCSSFromStyleObject(sanitizedStyles)
    } else {
      hookEvent.keepAttr = false
    }
  }
}

DOMPurify.removeHooks("uponSanitizeAttribute")
DOMPurify.addHook("uponSanitizeAttribute", styleFilterHookOverride)
